<template>
    <div class="mobile-sidebar" :class="{open: openSendwich}" v-if="setup != null">
        <div class="mobile-lang">
            <ul class="lang-link-select">
                <li class="body-lang-kz"><a href="#" @click.prevent="setLocale('kz/')">Каз</a></li>
                <li class="body-lang-ru"><a href="#" @click.prevent="setLocale('')">Рус</a></li>
                <li class="body-lang-en"><a href="#" @click.prevent="setLocale('en/')">Eng</a></li>
            </ul>
        </div>
        <navMain></navMain>
    </div>
</template>

<script>
    import navMain from '@/components/nav-main/mobile-nav-main.vue'
    import SlideUpDown from 'vue-slide-up-down'
    import {mapGetters} from 'vuex'
    export default {
        name: 'mobileSidebar',
        data () {
            return {
            }
        },
        components: {
            navMain,
            SlideUpDown,
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            openSendwich: 'loadOpenSendwich',
            currentCityArr: 'loadCurrentCityArr',
        }),
        methods: {
            setLocale(lang) {
                localStorage.setItem('languageBCN', lang);
                document.location.reload(true);
            },
            closeMobileMenu(data) {
                this.$store.commit('Open_Sendwich', data);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            },
            changeLang() {
                var dataLang = window.body.data('language'),
                    btnKz = $('.body-lang-kz'),
                    btnRu = $('.body-lang-ru'),
                    btnEn = $('.body-lang-en'),
                    selectRu = $('.select-link-ru'),
                    selectKz = $('.select-link-kz'),
                    selectEn = $('.select-link-en'),
                    link = $('.lang-link-select'),
                    switchContainer = $('.select--languages');
                if (dataLang == '') {
                    btnRu.addClass('active');
                    selectRu.addClass('active');
                } else if (dataLang == 'kz') {
                    btnKz.addClass('active');
                    selectKz.addClass('active');
                } else {
                    btnEn.addClass('active');
                    selectEn.addClass('active');
                }
            }
            // disableOverlay() {
            //     this.$store.commit('Open_Sendwich', false);
            //     document.getElementsByTagName('body')[0].classList.remove('overlay-open');
            // }
        },
        created() {
        },
        mounted() {
            this.$store.watch(
                (state) => state.pageSetup,
                (newValue) => {
                    if (newValue) {
                        this.changeLang();
                    }
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/mobile-sidebar/mobile-sidebar.scss';
    // @import '@/styles/components/nav-main/respond-nav-main.scss';
</style>